import { useState } from "react";
import { Sun, Moon } from "lucide-react";

export function applyMode(mode) {
  const el = document.documentElement;
  el.classList.toggle("light", mode === "light");
  el.classList.toggle("dark", mode !== "light");
}

export const initMode = () => applyMode(localStorage.getItem("ui_theme") || "dark");

export default function ThemeToggle() {
  const [mode, setMode] = useState(localStorage.getItem("ui_theme") || "dark");
  const toggle = () => {
    const m = mode === "light" ? "dark" : "light";
    localStorage.setItem("ui_theme", m);
    applyMode(m);
    setMode(m);
  };
  return (
    <button onClick={toggle} className="h-10 w-10 grid place-items-center rounded-md hover:bg-zinc-900" title={mode === "light" ? "Tema scuro" : "Tema chiaro"} data-testid="theme-toggle">
      {mode === "light" ? <Moon size={18} /> : <Sun size={18} />}
    </button>
  );
}
